import {
  Box,
  Button,
  Hidden,
  List,
  ListItem,
  makeStyles,
  Paper,
  Typography,
} from "@material-ui/core";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import CreateMeeting from "Admin/SuperAdmin/CreateMeeting";
import instance from "api/globalaxios";
import { removeSessionStorage } from "features/tiac_header_waiting/TiacAppHeader";
import React, { useEffect, useState } from "react";
import { FormattedMessage } from "react-intl";
import { useHistory } from "react-router-dom";
import { getWindowDimension } from "utils/responsiveUtils";
import Calender from "./Calender";
import CaseManager from "./CaseManagerSideBar";
import CreateAccount from "./CreateAccount";
// import CreateDispute from "./CreateDispute";
import Drive from "./Drive";
import Mediator from "./Mediator";
import Overview from "./Overview";
import UserDetails from "./UserDetails";
import MediationRequestPage from "../Form/MediationRequestPage";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    width: "100%",
    minHeight: "95vh",
    // height: "100%",
    borderRadius: "1rem",
    // flexDirection: (props) => (props.smallScreen ? "column" : "row"),
  },
  sidebar: {
    background: "#2C2C2C",
    width: "23rem",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
  },
  sidebarItem: {
    //#A4A6B3;
    fontSize: "16px",
    padding: "0.5rem 4rem",
    color: "#A4A6B3",
    letterSpacing: "0.2px",
    [theme.breakpoints.down("md")]: {
      fontSize: "16px",
      padding: "0.5rem 2.5rem",
    },
    [theme.breakpoints.down("xs")]: {
      fontSize: "14px",
      padding: "0.4rem 0 0.4rem 3rem",
    },
  },
  selected: {
    backgroundColor: "rgba(159, 162, 180, 0.08)",
    // opacity: 0.08,
    // color:"#FFFFFF",
    borderLeft: "2px solid #FFFFFF;",
  },
  body: {
    display: "flex",
    flexDirection: "column",
    flexGrow: 1,
    padding: "0",
    overflow: "hidden",
    width: "100%",
    textAlign: "center",
  },
  body2: {
    display: "flex",
    flexDirection: "column",
    flexGrow: 1,
    padding: "0",
    overflow: "hidden",
    width: "100%",
    textAlign: "center",
  },
}));

export default function AdminDashboard({ profile }) {
  const classes = useStyles();
  let history = useHistory();

  let ls = sessionStorage.getItem("tiac_sidebar_step");
  let mb = sessionStorage.getItem("tiac_sidebar_mobilestep");

  const [step, setStep] = useState(mb ? mb : 0);

  // Nalsar has no arbitration flow; the old Arbitrators tab (5) opens Overview instead
  const [selected, setSelected] = useState(
    ls && ls != 5 ? ls : getWindowDimension().width < 960 ? 0 : 1
  );

  const RenderOptions = () => {
    if (selected == 1 || selected == 0) {
      return <Overview profile={profile} />;
    }
    if (selected == 2) {
      return <CreateAccount profile={profile} />;
    }
    if (selected == 3) {
      return <UserDetails profile={profile} />;
    }
    if (selected == 4) {
      return <Mediator profile={profile} />;
    }
    // if (selected == 6) {
    //   // councel
    //   return ;
    // }
    if (selected == 7) {
      return <CaseManager profile={profile} />;
    }
    if (selected == 8) {
      return <CreateMeeting profile={profile} />;
    }
    if (selected == 9) {
      return <Drive profile={profile} />;
    }
    if (selected == 10) {
      return <Calender profile={profile} />;
    }
    if (selected == 11) {
      // return <CreateDispute />;
      return <MediationRequestPage/>
    }
  };

  const Sidebar = () => {
    return (
      <Box className={classes.sidebar}>
        <Box height="1rem"></Box>
        <Typography
          style={{
            padding: "15px 20px 30px 20px",
            fontSize: "18px",
            color: "rgba(238, 238, 238, 0.7)",
            fontWeight: "bold",
          }}
        >
          Dashboard
        </Typography>

        <List style={{ paddingTop: "0" }}>
          {selected == 1 ? (
            <ListItem
              className={classes.selected}
              button
              onClick={() => {
                setSelected(1);
                setStep(1);
                removeSessionStorage();
                history.push("/");
              }}
            >
              <Typography
                className={classes.sidebarItem}
                style={{ color: "#FFFFFF" }}
              >
                Overview
              </Typography>
            </ListItem>
          ) : (
            <ListItem
              button
              onClick={() => {
                setSelected(1);
                setStep(1);
                // history.push('/')
                removeSessionStorage();
                sessionStorage.setItem("tiac_sidebar_mobilestep", 1);
                sessionStorage.setItem("tiac_sidebar_step", 1);
              }}
            >
              <Typography className={classes.sidebarItem}>Overview</Typography>
            </ListItem>
          )}
          {selected == 2 ? (
            <ListItem
              className={classes.selected}
              button
              onClick={() => {
                setSelected(2);
                setStep(1);
              }}
            >
              <Typography
                className={classes.sidebarItem}
                style={{ color: "#FFFFFF" }}
              >
                Create Accounts
              </Typography>
            </ListItem>
          ) : (
            <ListItem
              button
              onClick={() => {
                setSelected(2);
                setStep(1);
                removeSessionStorage();
                sessionStorage.setItem("tiac_sidebar_step", 2);
                sessionStorage.setItem("tiac_sidebar_mobilestep", 1);
              }}
            >
              <Typography className={classes.sidebarItem}>
                Create Accounts
              </Typography>
            </ListItem>
          )}
          {selected == 3 ? (
            <ListItem
              className={classes.selected}
              button
              onClick={() => {
                setSelected(3);
                setStep(1);
              }}
            >
              <Typography
                className={classes.sidebarItem}
                style={{ color: "#FFFFFF" }}
              >
                User Details
              </Typography>
            </ListItem>
          ) : (
            <ListItem
              button
              onClick={() => {
                setSelected(3);
                setStep(1);
                removeSessionStorage();
                sessionStorage.setItem("tiac_sidebar_step", 3);
                sessionStorage.setItem("tiac_sidebar_mobilestep", 1);
              }}
            >
              <Typography className={classes.sidebarItem}>
                User Details
              </Typography>
            </ListItem>
          )}

          {selected == 4 ? (
            <ListItem
              className={classes.selected}
              button
              onClick={() => {
                setSelected(4);
                setStep(1);
              }}
            >
              <Typography
                className={classes.sidebarItem}
                style={{ color: "#FFFFFF" }}
              >
                Mediators
              </Typography>
            </ListItem>
          ) : (
            <ListItem
              button
              onClick={() => {
                setSelected(4);
                setStep(1);
                removeSessionStorage();
                sessionStorage.setItem("tiac_sidebar_step", 4);
                sessionStorage.setItem("tiac_sidebar_mobilestep", 1);
              }}
            >
              <Typography className={classes.sidebarItem}>
                Mediators
              </Typography>
            </ListItem>
          )}

          {/* {(selected == 6 ? (
            <ListItem
              className={classes.selected}
              button
              onClick={() => {
                setSelected(6);
                setStep(1);
              }}
            >
              <Typography
                className={classes.sidebarItem}
                style={{ color: "#FFFFFF" }}
              >
                Counsel
              </Typography>
            </ListItem>
          ) : (
            <ListItem
              button
              onClick={() => {
                setSelected(6);
                setStep(1);
                removeSessionStorage();
                sessionStorage.setItem("tiac_sidebar_step", 6);
                sessionStorage.setItem("tiac_sidebar_mobilestep", 1);
              }}
            >
              <Typography className={classes.sidebarItem}>
                Counsel
              </Typography>
            </ListItem>
          ))} */}

          {profile.profile_type == "sub_admin_tiac_rv" &&
            (selected == 7 ? (
              <ListItem
                className={classes.selected}
                button
                onClick={() => {
                  setSelected(7);
                  setStep(1);
                }}
              >
                <Typography
                  className={classes.sidebarItem}
                  style={{ color: "#FFFFFF" }}
                >
                  Case Managers
                </Typography>
              </ListItem>
            ) : (
              <ListItem
                button
                onClick={() => {
                  setSelected(7);
                  setStep(1);
                  removeSessionStorage();
                  sessionStorage.setItem("tiac_sidebar_step", 7);
                  sessionStorage.setItem("tiac_sidebar_mobilestep", 1);
                }}
              >
                <Typography className={classes.sidebarItem}>
                  Case Managers
                </Typography>
              </ListItem>
            ))}

          {(selected == 8 ? (
            <ListItem
              className={classes.selected}
              button
              onClick={() => {
                setSelected(8);
                setStep(1);
              }}
            >
              <Typography
                className={classes.sidebarItem}
                style={{ color: "#FFFFFF" }}
              >
                Create Meeting
              </Typography>
            </ListItem>
          ) : (
            <ListItem
              button
              onClick={() => {
                setSelected(8);
                setStep(1);
                removeSessionStorage();
                sessionStorage.setItem("tiac_sidebar_step", 8);
                sessionStorage.setItem("tiac_sidebar_mobilestep", 1);
              }}
            >
              <Typography className={classes.sidebarItem}>
                Create Meeting
              </Typography>
            </ListItem>
          ))}

          
          
          {selected == 9 ? (
            <ListItem
              className={classes.selected}
              button
              onClick={() => {
                setSelected(9);
                setStep(1);
              }}
            >
              <Typography
                className={classes.sidebarItem}
                style={{ color: "#FFFFFF" }}
              >
                Drive
              </Typography>
            </ListItem>
          ) : (
            <ListItem
              button
              onClick={() => {
                setSelected(9);
                setStep(1);
                removeSessionStorage();
                sessionStorage.setItem("tiac_sidebar_step", 9);
                sessionStorage.setItem("tiac_sidebar_mobilestep", 1);
              }}
            >
              <Typography className={classes.sidebarItem}>Drive</Typography>
            </ListItem>
          )}
          {selected == 10 ? (
            <ListItem
              className={classes.selected}
              button
              onClick={() => {
                setSelected(10);
                setStep(1);
              }}
            >
              <Typography
                className={classes.sidebarItem}
                style={{ color: "#FFFFFF" }}
              >
                Calendar
              </Typography>
            </ListItem>
          ) : (
            <ListItem
              button
              onClick={() => {
                setSelected(10);
                setStep(1);
                removeSessionStorage();
                sessionStorage.setItem("tiac_sidebar_step", 10);
                sessionStorage.setItem("tiac_sidebar_mobilestep", 1);
              }}
            >
              <Typography className={classes.sidebarItem}>Calendar</Typography>
            </ListItem>
          )}

          {selected == 11 ? (
            <ListItem
              className={classes.selected}
              button
              onClick={() => {
                setSelected(11);
                setStep(1);
              }}
            >
              <Typography
                className={classes.sidebarItem}
                style={{ color: "#FFFFFF" }}
              >
                Create Dispute
              </Typography>
            </ListItem>
          ) : (
            <ListItem
              button
              onClick={() => {
                setSelected(11);
                setStep(1);
                removeSessionStorage();
                sessionStorage.setItem("tiac_sidebar_step", 11);
                sessionStorage.setItem("tiac_sidebar_mobilestep", 1);
              }}
            >
              <Typography className={classes.sidebarItem}>
                Create Dispute
              </Typography>
            </ListItem>
          )}
        </List>
      </Box>
    );
  };

  const Body = () => {
    return (
      <Box className={classes.body2}>
        <Hidden mdUp>
          <Paper
            style={{
              background: "none",
              border: "none",
              boxShadow: "none",
              display: "flex",
              justifyContent: "flex-start",
              padding: "15px 20px",
            }}
          >
            <Button
              size="large"
              onClick={(e) => {
                setStep(0);
                setSelected(0);
                removeSessionStorage();
              }}
              startIcon={<ArrowBackIosIcon />}
            >
              <FormattedMessage id="buttons.back" />
            </Button>
          </Paper>
        </Hidden>
        <Box className={classes.body}>
          <RenderOptions />
        </Box>
      </Box>
    );
  };

  const MobileView = ({ step }) => {
    switch (step) {
      case 0:
      case "0":
        return <Sidebar />;
      case 1:
      case "1":
        return <Body />;
      default:
        return null;
    }
  };

  return (
    <Box className={classes.root}>
      <Hidden smDown>
        <>
          <Sidebar />
          <Body />
        </>
      </Hidden>
      <Hidden mdUp>
        <MobileView step={step} />
      </Hidden>
    </Box>
  );
}
